import type { RouteRecordRaw } from 'vue-router';


export const AboutRoute: RouteRecordRaw = {
  path: '/about',
  name: 'About',
  component: () =>
    import('@/pages/about/index.vue'),
};
